import { injectIntl } from 'react-intl';
import { SearchBox as OriginalSearchBox} from './SearchBox.index';

class SearchBox extends OriginalSearchBox {

    inputChange() {
        this.setState({ searchButtonEnabled: true })
    }
}

// Wraps the component in order to provide intl prop to it. We use this in order
// to access the Intl API so that we can use messages without placeholders.
export default injectIntl(SearchBox);


// WEBPACK FOOTER //
// ./src/scripts/reusable/SearchBox/SearchBox.selectableTable.jsx